import produce from "immer";
import { State } from "../types";

export function updateExecutionStatus(
  state: State,
  update: UpdateExecutionStatus["payload"]
) {
  return produce(state, draft => {
    draft.rule.enabled = update;
  });
}

export type UpdateExecutionStatus = {
  type: "updateExecutionStatus";
  payload: boolean;
};
